/**
 * Сцена приложения: что движок строит на себе — поле в сборе из блоков — и какими звуками. Блоки и банк звуков грузятся
 * лениво, вместе с движком: лобби их не тянет, а движок о них ничего не знает (`engines/index.ts`).
 */

import type { Playfield } from './blocks/board.js'
import { loadSheet } from './assets.js'
import type { Resources } from './engines/base.js'
import type { Scenery } from './engines/index.js'

/** Ассеты клиента лежат в `src/public/` и отдаются с корня. */
const ASSET_DIR = '/'

export const scenery: Scenery<Playfield> = async () => {
  const [{ buildPlayfield }, { bank }, { loadImage }] = await Promise.all([
    import('./blocks/board.js'),
    import('./app.sounds.js'),
    import('./engines/base.js'),
  ])
  const resources: Resources = {
    sheet: (file) => loadSheet(ASSET_DIR + file),
    image: (file) => loadImage(ASSET_DIR + file),
    color: (name) => getComputedStyle(document.documentElement).getPropertyValue(name).trim(),
  }
  return (engine) => buildPlayfield(engine, bank, resources)
}
